'use strict';

/**
 * View for rendering the selection of a location in modal update/select location
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var SelectStoragesItemView = require('./select-storages-item');

var template = require('../../templates/partials/select-storages-list.hbs');

var SelectStoragesListView = ColidoCompositeView.extend({
    template: template,

    childView: SelectStoragesItemView,

    /**
     * Should the messenger be showed?
     * @type {boolean}
     */
    showCreateMessage: true,

    childViewContainer: '.list',

    ui: {
        'addStorageBox': '.box-add-storage',
        'createStorage': '[data-action="toggle-creation"]',
        'createButton': '[data-action="create"]',
        'resetButton': '[data-action="reset"]',
        'selectStorage': '[data-action="select-storage"]',
        'nameInput': 'input[name="name"]',
        'addLocationForm': 'form',
    },

    events: {
        'click @ui.createStorage': 'onToggleCreation',
        'click @ui.createButton': 'onCreateStorage',
        'click @ui.resetButton': 'onResetCreate',
        'click @ui.selectStorage': 'onSelectStorage',
        'keyup @ui.nameInput': 'onCheckName',
        'keydown @ui.nameInput': 'onCheckName',
        'change @ui.nameInput': 'onCheckName',
        'submit @ui.addLocationForm': 'onFormSubmit',
    },

    /**
     * Is triggered, when the main storage is selected
     * We will notify the layoutview
     */
    onSelectStorage: function() {
        var level = this.$el.parents('.lane').data('level');
        this.triggerMethod('storage:selected', level, this.model);
    },

    /**
     * Toggles the edit mode of the box
     * @return {void}
     */
    onToggleCreation: function() {
        var mode  = this.ui.addStorageBox.attr('data-mode');
        var empty = this.ui.addStorageBox.attr('data-empty');

        if (empty === true || empty === 'true') {
            if (mode === 'view') {
                this.ui.addStorageBox.addClass('box-stacked').removeClass('box-empty');
                this.ui.addStorageBox.attr('data-mode', 'edit');
                this.ui.createButton.prop('disabled', true);
                this.ui.nameInput.focus();
            } else {
                this.ui.addStorageBox.removeClass('box-stacked').addClass('box-empty');
                this.ui.addStorageBox.attr('data-mode', 'view');
            }
        }
    },

    /**
     * Cancles the creation of a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    onResetCreate: function(event) {
        event.preventDefault();
        this.ui.nameInput.val('');
        this.onToggleCreation();
    },

    /**
     * Checks the name to enable/disable submit button
     * @param {object} event The event that has triggered the function
     */
    onCheckName: function() {
        this.ui.createButton.prop('disabled', this.ui.nameInput.val().length <= 0);
    },

    /**
     * Triggered, when the creation form is submitted
     * @param {object} event Submit event
     */
    onFormSubmit: function(event) {
        event.preventDefault();
    },

    /**
     * Creates a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    onCreateStorage: function(event) {
        event.preventDefault();
        var name = this.ui.nameInput.val();
        var catalog = this.collection.catalog;

        // Request add
        var parentId = (this.model && this.model.get('id')) || 0;
        App.radio('collection:location').execute('create:storage', catalog, name, parentId, this.getOption('showCreateMessage'));

        // Disable edit mode
        this.ui.nameInput.val('');
        this.onToggleCreation();
    },

    onShow: function() {
        if (this.getOption('forceAdd')) { //We will jump into create dialog, when there is forceAdd Option
            this.onToggleCreation();
        }
    },
});

module.exports = SelectStoragesListView;